/*
创建者 李伟(2018.11.02)
活动页面
*/
<template>
  <div class="activity">
    <div class="img-top" :style="{background:`url(${topImgBg}) top center`}"></div>
    <div class="wrapper">
      <div class="a-title"><img :src="title01"/></div>
      <div class="a-box">
        <ul v-if="list01.length" class="imglist">
          <li v-for="item in list01"><a :href="item.url" target="_blank"><img :src="item.atturl" /></a></li>
        </ul>
      </div>
      <div class="a-title"><img :src="title01"/></div>
      <div class="a-box">
        <div class="left"><a v-if="list02[0]" :href="list02[0].url" target="_blank"><img :src="list02[0].atturl" /></a></div>
        <div class="middle">
          <a v-if="list02[1]" :href="list02[1].url" target="_blank"><img :src="list02[1].atturl" /></a>
          <a v-if="list02[2]" :href="list02[2].url" target="_blank"><img :src="list02[2].atturl" /></a>
          <a v-if="list02[3]" :href="list02[3].url" target="_blank"><img :src="list02[3].atturl" /></a>
          <a v-if="list02[4]" :href="list02[4].url" target="_blank"><img :src="list02[4].atturl" /></a>
          <a v-if="list02[5]" :href="list02[5].url" target="_blank"><img :src="list02[5].atturl" /></a>
        </div>
        <div class="right">
          <a v-if="list02[6]" :href="list02[6].url" target="_blank"><img :src="list02[6].atturl" /></a>
          <a v-if="list02[7]" :href="list02[7].url" target="_blank"><img :src="list02[7].atturl" /></a>
          <a v-if="list02[8]" :href="list02[8].url" target="_blank"><img :src="list02[8].atturl" /></a>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="a-title"><img :src="title02"/></div>
      <div class="a-box">
        <div class="left"><a v-if="list03[0]" :href="list03[0].url" target="_blank"><img :src="list03[0].atturl" /></a></div>
        <div class="middle">
          <a v-if="list03[1]" :href="list03[1].url" target="_blank"><img :src="list03[1].atturl" /></a>
          <a v-if="list03[2]" :href="list03[2].url" target="_blank"><img :src="list03[2].atturl" /></a>
          <a v-if="list03[3]" :href="list03[3].url" target="_blank"><img :src="list03[3].atturl" /></a>
          <a v-if="list03[4]" :href="list03[4].url" target="_blank"><img :src="list03[4].atturl" /></a>
          <a v-if="list03[5]" :href="list03[5].url" target="_blank"><img :src="list03[5].atturl" /></a>
        </div>
        <div class="right">
          <a v-if="list03[6]" :href="list03[6].url" target="_blank"><img :src="list03[6].atturl" /></a>
          <a v-if="list03[7]" :href="list03[7].url" target="_blank"><img :src="list03[7].atturl" /></a>
          <a v-if="list03[8]" :href="list03[8].url" target="_blank"><img :src="list03[8].atturl" /></a>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="a-title"><img :src="title03"/></div>
      <div class="a-box">
        <div class="left"><a v-if="list04[0]" :href="list04[0].url" target="_blank"><img :src="list04[0].atturl" /></a></div>
        <div class="middle">
          <a v-if="list04[1]" :href="list04[1].url" target="_blank"><img :src="list04[1].atturl" /></a>
          <a v-if="list04[2]" :href="list04[2].url" target="_blank"><img :src="list04[2].atturl" /></a>
          <a v-if="list04[3]" :href="list04[3].url" target="_blank"><img :src="list04[3].atturl" /></a>
          <a v-if="list04[4]" :href="list04[4].url" target="_blank"><img :src="list04[4].atturl" /></a>
          <a v-if="list04[5]" :href="list04[5].url" target="_blank"><img :src="list04[5].atturl" /></a>
        </div>
        <div class="right">
          <a v-if="list04[6]" :href="list04[6].url" target="_blank"><img :src="list04[6].atturl" /></a>
          <a v-if="list04[7]" :href="list04[7].url" target="_blank"><img :src="list04[7].atturl" /></a>
          <a v-if="list04[8]" :href="list04[8].url" target="_blank"><img :src="list04[8].atturl" /></a>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="a-title"><img :src="title04"/></div>
      <div class="a-box">
        <div class="left"><a v-if="list05[0]" :href="list05[0].url" target="_blank"><img :src="list05[0].atturl" /></a></div>
        <div class="middle">
          <a v-if="list05[1]" :href="list05[1].url" target="_blank"><img :src="list05[1].atturl" /></a>
          <a v-if="list05[2]" :href="list05[2].url" target="_blank"><img :src="list05[2].atturl" /></a>
          <a v-if="list05[3]" :href="list05[3].url" target="_blank"><img :src="list05[3].atturl" /></a>
          <a v-if="list05[4]" :href="list05[4].url" target="_blank"><img :src="list05[4].atturl" /></a>
          <a v-if="list05[5]" :href="list05[5].url" target="_blank"><img :src="list05[5].atturl" /></a>
        </div>
        <div class="right">
          <a v-if="list05[6]" :href="list05[6].url" target="_blank"><img :src="list05[6].atturl" /></a>
          <a v-if="list05[7]" :href="list05[7].url" target="_blank"><img :src="list05[7].atturl" /></a>
          <a v-if="list05[8]" :href="list05[8].url" target="_blank"><img :src="list05[8].atturl" /></a>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>
<script>

  import {getActivity} from 'api/home';

  export default {
    data(){
      return{
        topImgBg:'',
        title01:'',
        title02:'',
        title03:'',
        title04:'',
        list01:[],
        list02:[],
        list03:[],
        list04:[],
        list05:[]
      }
    },
    created(){
      this.getActivityData();
    },
    methods:{
      getActivityData(){
        getActivity().then(json=>{
          if (json.resCode == '1') {
          if(json.data.topBackgroundAdvertisementDTO.advList[0])
          this.topImgBg = json.data.topBackgroundAdvertisementDTO.advList[0].atturl;//标题
          if(json.data.firstTitleAdvertisementDTO.advList[0])
          this.title01 =  json.data.firstTitleAdvertisementDTO.advList[0].atturl;//标题
          if(json.data.secondTitleAdvertisementDTO.advList[0])
          this.title02 =  json.data.secondTitleAdvertisementDTO.advList[0].atturl;//标题
          if(json.data.thirdTitleAdvertisementDTO.advList[0])
          this.title03 =  json.data.thirdTitleAdvertisementDTO.advList[0].atturl;//标题
          if(json.data.fourthTitleAdvertisementDTO.advList[0])
          this.title04 =  json.data.fourthTitleAdvertisementDTO.advList[0].atturl;//标题

          if(json.data.firstActiveAdvertisementDTO.advList[0])
          this.list01.push(json.data.firstActiveAdvertisementDTO.advList[0]);//精品好货
          if(json.data.secondActiveAdvertisementDTO.advList[0])
          this.list01.push(json.data.secondActiveAdvertisementDTO.advList[0]);//精品好货
          if(json.data.thirdActiveAdvertisementDTO.advList[0])
          this.list01.push(json.data.thirdActiveAdvertisementDTO.advList[0]);//精品好货
          if(json.data.fourthActiveAdvertisementDTO.advList[0])
          this.list01.push(json.data.fourthActiveAdvertisementDTO.advList[0]);//精品好货
          if(json.data.fifthActiveAdvertisementDTO.advList[0])
          this.list01.push(json.data.fifthActiveAdvertisementDTO.advList[0]);//精品好货

          if(json.data.secondActiveLeftAdvertisementDTO.advList[0])
          this.list02.push(json.data.secondActiveLeftAdvertisementDTO.advList[0]);//左侧
          if(json.data.secondActiveCenterAdvertisementDTO.advList[0])
          this.list02.push(json.data.secondActiveCenterAdvertisementDTO.advList[0]);//中上
          if(json.data.secondActiveMinAdvertisementDTO.advList[0])
          this.list02.push(json.data.secondActiveMinAdvertisementDTO.advList[0]);//中小
          if(json.data.secondActiveMinAdvertisementDTO.advList[1])
          this.list02.push(json.data.secondActiveMinAdvertisementDTO.advList[1]);//中小
          if(json.data.secondActiveMinAdvertisementDTO.advList[2])
          this.list02.push(json.data.secondActiveMinAdvertisementDTO.advList[2]);//中小
          if(json.data.secondActiveMinAdvertisementDTO.advList[3])
          this.list02.push(json.data.secondActiveMinAdvertisementDTO.advList[3]);//中小
          if(json.data.secondActiveRightAdvertisementDTO.advList[0])
          this.list02.push(json.data.secondActiveRightAdvertisementDTO.advList[0]);//右上
          if(json.data.secondActiveDownAdvertisementDTO.advList[0])
          this.list02.push(json.data.secondActiveDownAdvertisementDTO.advList[0]);//右下小
          if(json.data.secondActiveDownAdvertisementDTO.advList[1])
          this.list02.push(json.data.secondActiveDownAdvertisementDTO.advList[1]);//右下小

          if(json.data.thirdActiveLeftAdvertisementDTO.advList[0])
          this.list03.push(json.data.thirdActiveLeftAdvertisementDTO.advList[0]);//左侧
          if(json.data.thirdActiveCenterUpAdvertisementDTO.advList[0])
          this.list03.push(json.data.thirdActiveCenterUpAdvertisementDTO.advList[0]);//中上
          if(json.data.thirdActiveCenterMinAdvertisementDTO.advList[0])
          this.list03.push(json.data.thirdActiveCenterMinAdvertisementDTO.advList[0]);//中小
          if(json.data.thirdActiveCenterMinAdvertisementDTO.advList[1])
          this.list03.push(json.data.thirdActiveCenterMinAdvertisementDTO.advList[1]);//中小
          if(json.data.thirdActiveCenterMinAdvertisementDTO.advList[2])
          this.list03.push(json.data.thirdActiveCenterMinAdvertisementDTO.advList[2]);//中小
          if(json.data.thirdActiveCenterMinAdvertisementDTO.advList[3])
          this.list03.push(json.data.thirdActiveCenterMinAdvertisementDTO.advList[3]);//中小
          if(json.data.thirdActiveRightUpAdvertisementDTO.advList[0])
          this.list03.push(json.data.thirdActiveRightUpAdvertisementDTO.advList[0]);//右上
          if(json.data.thirdActiveRightDownAdvertisementDTO.advList[0])
          this.list03.push(json.data.thirdActiveRightDownAdvertisementDTO.advList[0]);//右下小
          if(json.data.thirdActiveRightDownAdvertisementDTO.advList[1])
          this.list03.push(json.data.thirdActiveRightDownAdvertisementDTO.advList[1]);//右下小

          if(json.data.fourthActiveLeftAdvertisementDTO.advList[0])
          this.list04.push(json.data.fourthActiveLeftAdvertisementDTO.advList[0]);//左侧
          if(json.data.fourthActiveCenterUpAdvertisementDTO.advList[0])
          this.list04.push(json.data.fourthActiveCenterUpAdvertisementDTO.advList[0]);//中上
          if(json.data.fourthActiveCenterMinAdvertisementDTO.advList[0])
          this.list04.push(json.data.fourthActiveCenterMinAdvertisementDTO.advList[0]);//中小
          if(json.data.fourthActiveCenterMinAdvertisementDTO.advList[1])
          this.list04.push(json.data.fourthActiveCenterMinAdvertisementDTO.advList[1]);//中小
          if(json.data.fourthActiveCenterMinAdvertisementDTO.advList[2])
          this.list04.push(json.data.fourthActiveCenterMinAdvertisementDTO.advList[2]);//中小
          if(json.data.fourthActiveCenterMinAdvertisementDTO.advList[3])
          this.list04.push(json.data.fourthActiveCenterMinAdvertisementDTO.advList[3]);//中小
          if(json.data.fourthActiveRightUpAdvertisementDTO.advList[0])
          this.list04.push(json.data.fourthActiveRightUpAdvertisementDTO.advList[0]);//右上
          if(json.data.fourthActiveRightDownAdvertisementDTO.advList[0])
          this.list04.push(json.data.fourthActiveRightDownAdvertisementDTO.advList[0]);//右下小
          if(json.data.fourthActiveRightDownAdvertisementDTO.advList[1])
          this.list04.push(json.data.fourthActiveRightDownAdvertisementDTO.advList[1]);//右下小

          if(json.data.fifthActiveLeftAdvertisementDTO.advList[0])
          this.list05.push(json.data.fifthActiveLeftAdvertisementDTO.advList[0]);//左侧
          if(json.data.fifthActiveCenterUpAdvertisementDTO.advList[0])
          this.list05.push(json.data.fifthActiveCenterUpAdvertisementDTO.advList[0]);//中上
          if(json.data.fifthActiveCenterMinAdvertisementDTO.advList[0])
          this.list05.push(json.data.fifthActiveCenterMinAdvertisementDTO.advList[0]);//中小
          if(json.data.fifthActiveCenterMinAdvertisementDTO.advList[1])
          this.list05.push(json.data.fifthActiveCenterMinAdvertisementDTO.advList[1]);//中小
          if(json.data.fifthActiveCenterMinAdvertisementDTO.advList[2])
          this.list05.push(json.data.fifthActiveCenterMinAdvertisementDTO.advList[2]);//中小
          if(json.data.fifthActiveCenterMinAdvertisementDTO.advList[3])
          this.list05.push(json.data.fifthActiveCenterMinAdvertisementDTO.advList[3]);//中小
          if(json.data.fifthActiveRightUpAdvertisementDTO.advList[0])
          this.list05.push(json.data.fifthActiveRightUpAdvertisementDTO.advList[0]);//右上
          if(json.data.fifthActiveRightDownAdvertisementDTO.advList[0])
          this.list05.push(json.data.fifthActiveRightDownAdvertisementDTO.advList[0]);//右下小
          if(json.data.fifthActiveRightDownAdvertisementDTO.advList[1])
          this.list05.push(json.data.fifthActiveRightDownAdvertisementDTO.advList[1]);//右下小
        } else {
          this.$Message.info(json.resDesc);
        }
        });
      }
    }
  }
</script>
<style lang="less">
  @import "../../assets/css/activity.less";
</style>



// WEBPACK FOOTER //
// index.vue?830186f6